import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e220fdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "students-list" }

import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import { Student } from '@/http/pageModels/teacherModels/classPage/AllStudentsResponseModel';
import { AllStudentsService } from '@/http/services/TeacherServices/ClassPageServices/AllStudentsService';
import router from '@/router';
import { onMounted, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AllStudentsSubpage',
  setup(__props) {

const state = reactive<{ data: Student[] }>({
    data: [],
});

onMounted(() => {
    const classId = router.currentRoute.value.params.classId;

    AllStudentsService.getAllStudents(+classId).then((response) => {
        state.data = response.data.students;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data, (student) => {
      return (_openBlock(), _createBlock(UniversalCard, {
        key: student.studentId,
        props: {
                type: 'outlined',
                content: student.getFullName,
            }
      }, null, 8, ["props"]))
    }), 128))
  ]))
}
}

})